namespace TabAurous.Common {
    export namespace CommonService {
        export const baseUrl = 'Common/CommonEndpoint';

        export declare function Authorize(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemDiscount(request: LaborRateRequest, onSuccess?: (response: Serenity.ListResponse<Retail.POSSalesLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumbers(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateProductImages(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<OMS.ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Authorize = "Common/CommonEndpoint/Authorize",
            GetItemDiscount = "Common/CommonEndpoint/GetItemDiscount",
            GetNextNumbers = "Common/CommonEndpoint/GetNextNumbers",
            UpdateProductImages = "Common/CommonEndpoint/UpdateProductImages"
        }

        [
            'Authorize', 
            'GetItemDiscount', 
            'GetNextNumbers', 
            'UpdateProductImages'
        ].forEach(x => {
            (<any>CommonService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
